import { FC } from "react";
import { Stack, Title } from "@mantine/core";
import { UploadCVForm } from "../../features/upload-cv/UploadCVForm";
import { useTranslation } from "react-i18next";

interface Props {
  onUpload: () => void;
}

export const UploadCVWiget: FC<Props> = ({ onUpload }) => {
  const { t } = useTranslation();

  return (
    <Stack align="stretch" justify="center" gap="34px">
      <Title size={36}>{t("upload_cv")}</Title>
      <UploadCVForm onUpload={onUpload} />
    </Stack>
  );
};
